<template>
    <div id="no-emission-alert-form-component">
        <v-text-field
            v-model="configuration.limit"
            :label="$t('dialog_update_alert_component.number_hours_without_emissions')"
            filled
            type="number"
        />
    </div>
</template>

<script>
export default {
    name: 'NoEmissionAlertFormComponent',
    props: {
        configuration: {
            type: Object,
            required: true,
        },
    },
}
</script>
